interface HeaderProps {
  busy: boolean;
}

export function Header({ busy }: HeaderProps) {
  return (
    <header className="border-b-[3px] border-ink bg-crate text-cream">
      <div className="hazard h-2.5 border-b-[3px] border-ink" />
      <div className="mx-auto flex max-w-[1200px] items-center justify-between gap-3 px-4 py-3 sm:px-6">
        <a href="/" className="flex items-center gap-3">
          <span className="grid h-10 w-10 place-items-center border-[3px] border-ink bg-acid font-slam text-2xl leading-none text-ink">
            S
          </span>
          <span className="font-slam text-3xl uppercase leading-none tracking-wide">
            SonarImg
          </span>
        </a>
        <div className="flex items-center gap-2">
          <span className="hidden border-[3px] border-cream px-2 py-1 font-mono text-[10px] uppercase tracking-[0.14em] sm:inline">
            Lot 002 · Free
          </span>
          <span className="border-[3px] border-ink bg-tape px-2 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.14em] text-ink">
            {busy ? "IN PRESS" : "READY"}
          </span>
        </div>
      </div>
    </header>
  );
}
